import {FC, useState} from "react";
import {Badge, Button, Col, Container, Dropdown, Nav, Navbar, Offcanvas, Row,} from "react-bootstrap";
import rightRentalLogo from "../../../assets/images/right_rental_logo.png";
import redDevilLogo from "../../../assets/images/reddevil-logo.png";
import kitchenLogo from "../../../assets/images/kitchen_logo.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBars,
    faHamburger,
    faSignOut, faUser
} from "@fortawesome/free-solid-svg-icons";
import {appAuth} from "../../../index";
import {useLocation} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../hooks";
import {
    departmentNames,
    selectCurrentEmployee,
    selectCurrentUser, selectDepartment, setDepartment,
} from "../../../features/AppStateSlice";
import {selectAllEmployees} from "../../../features/AppDataSlice";
import MEmployeeStatistics from "../components/MEmployeeStatistics";

const MAppHeader: FC = () => {
    const dispatch = useAppDispatch();

    function userSignOut() {
        appAuth.signOut();
        window.location.href = window.location.href;
    }

    const location = useLocation();
    const currentUser = useAppSelector(selectCurrentUser);
    const currentEmployee = useAppSelector(selectCurrentEmployee);
    const employees = useAppSelector(selectAllEmployees);
    const department = useAppSelector(selectDepartment);
    const departmentName = departmentNames[department];
    const appLogo = department === "catering" ? redDevilLogo : (department === "store" ? kitchenLogo : rightRentalLogo);

    if (currentEmployee) {
        if (!currentEmployee.isMontage || !currentEmployee.isCatering || !currentEmployee.isStore || !currentEmployee.isLogistics) {
            if (!currentEmployee.isMontage && department === "montage") {
                dispatch(setDepartment("catering"));
            }
            if (!currentEmployee.isCatering && department === "catering") {
                dispatch(setDepartment("montage"));
            }
            if (!currentEmployee.isStore && department === "store") {
                dispatch(setDepartment("store"));
            }
            if (!currentEmployee.isLogistics && department === "logistics") {
                dispatch(setDepartment("logistics"));
            }
        }
    }

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    if (!currentUser) {
        return null;
    }

    return (<>
        <Navbar fixed="top" className={"app-header"}>
            <Container fluid>
                <Navbar.Brand href="/">
                    <img
                        src={appLogo}
                        height="40"
                        className="d-inline-block align-top"
                        alt="App logo"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="navbarScroll"/>
                <Navbar.Collapse id="navbarScroll">
                    <Nav
                        activeKey={location.pathname}
                        className="me-auto my-2 my-lg-0"
                        style={{maxHeight: '100px'}}
                        navbarScroll
                    >
                    </Nav>
                    <div className="d-flex">
                        <Dropdown className={"me-2"}>
                            <Dropdown.Toggle variant="dark"
                                             disabled={
                                                 (
                                                     (currentEmployee?.isMontage ? 1 : 0) +
                                                     (currentEmployee?.isCatering ? 1 : 0) +
                                                     (currentEmployee?.isStore ? 1 : 0) +
                                                     (currentEmployee?.isLogistics ? 1 : 0)
                                                 ) <= 1
                                             }
                                             style={{height: "40px"}}>
                            <span className={"text-uppercase fw-bold"}
                                  style={{color: "wheat"}}>{departmentName}&nbsp;&nbsp;</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu variant={"dark"}>
                                {
                                    (currentEmployee?.isMontage) &&
                                    <Dropdown.Item onClick={event => dispatch(setDepartment("montage"))}>
                                <span className={"text-uppercase fw-bold lh-2em"}
                                      style={{color: "wheat"}}>{departmentNames.montage}</span>
                                    </Dropdown.Item>
                                }
                                {
                                    (currentEmployee?.isCatering) &&
                                    <Dropdown.Item onClick={event => dispatch(setDepartment("catering"))}>
                                <span className={"text-uppercase fw-bold lh-2em"}
                                      style={{color: "wheat"}}>{departmentNames.catering}</span>
                                    </Dropdown.Item>
                                }
                                {
                                    (currentEmployee?.isStore) &&
                                    <Dropdown.Item onClick={event => dispatch(setDepartment("store"))}>
                                <span className={"text-uppercase fw-bold lh-2em"}
                                      style={{color: "wheat"}}>{departmentNames.store}</span>
                                    </Dropdown.Item>
                                }
                                {
                                    (currentEmployee?.isLogistics) &&
                                    <Dropdown.Item onClick={event => dispatch(setDepartment("logistics"))}>
                                <span className={"text-uppercase fw-bold lh-2em"}
                                      style={{color: "wheat"}}>{departmentNames.logistics}</span>
                                    </Dropdown.Item>
                                }
                            </Dropdown.Menu>
                        </Dropdown>

                        <Button variant="dark" onClick={handleShow} style={{height: "40px", width: "40px"}}>
                            <FontAwesomeIcon icon={faUser}/>
                        </Button>
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
        <Offcanvas show={show} onHide={handleClose}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title className={"w-100"}>
                    {
                        currentUser && <div className={"w-100"}>
                            <Row>
                                <Col xs={"auto"}>
                                    <Button variant="dark" onClick={userSignOut}>
                                        <FontAwesomeIcon icon={faSignOut}/>
                                    </Button>
                                </Col>
                                <Col>
                                    <h2>{currentUser.name}</h2>
                                </Col>
                            </Row>
                            <Row className={"mt-3 text-primary fst-italic small"}>
                                <Col xs={"auto"}>
                                    <Badge>{
                                        currentEmployee?.isSuperAdmin ? "Администратор" :
                                            (
                                                currentEmployee?.isAdmin ? "Оператор" : "Служител"
                                            )
                                    }
                                    </Badge>
                                </Col>
                                <Col xs={"auto"}><Badge>{currentEmployee?.isMontage && "Монтаж"}</Badge></Col>
                                <Col xs={"auto"}><Badge>{currentEmployee?.isCatering && "Кетъринг"}</Badge></Col>
                                <Col xs={"auto"}><Badge>{currentEmployee?.isStore && "Кухня"}</Badge></Col>
                                <Col xs={"auto"}><Badge>{currentEmployee?.isLogistics && "Транспорт"}</Badge></Col>
                            </Row>

                        </div>
                    }
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>

                        <MEmployeeStatistics />

            </Offcanvas.Body>
        </Offcanvas>
    </>);
}

export default MAppHeader;
